import { render } from "./IconPaper.vue?vue&type=template&id=625e7f44"
import script from "./IconPaper.vue?vue&type=script&lang=ts"
export * from "./IconPaper.vue?vue&type=script&lang=ts"
script.render = render

export default script